import React from 'react';
import { useTranslation } from 'react-i18next';
import './HeroSection.css';

/**
 * HeroSection - Full-width banner with LOVWhereYouWork graphic
 *
 * Uses the official banner image with team collaboration background
 * Features empowering imagery showing diverse professionals
 * Shows Spanish version when language is set to Spanish
 */
export function HeroSection() {
  const { t, i18n } = useTranslation();

  // Use Spanish header image when language is Spanish
  const headerImage = i18n.language === 'es'
    ? '/Lovewhere youworkAITool_Websiteheader_spanish subheadline.jpg'
    : '/Lovewhere youworkAITool_Websiteheader.jpg';

  const handleScrollToTool = () => {
    const toolSection = document.getElementById('tool');
    if (!toolSection) return;

    // Standalone (direct CloudFront URL): the app owns the scrollbar.
    toolSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Embedded (iframe on liftourvoices.org): the iframe is sized to its full
    // content height, so it has no scrollbar — the parent page must do the
    // scroll. Send the tool's offset within this document and let the parent
    // listener (see IFRAME_EMBED.md) scroll the page. Harmless when standalone
    // (window.parent === window, and no listener is registered).
    if (window.parent && window.parent !== window) {
      const offset = toolSection.getBoundingClientRect().top + window.scrollY;
      window.parent.postMessage({ type: 'lov:scrollTo', offset }, '*');
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        {/* Banner Image */}
        <div className="hero-banner-wrapper">
          <img
            src={headerImage}
            alt={t('hero.imageAlt')}
            className="hero-banner-image"
          />
        </div>

        {/* Scroll prompt - makes the tool easy to find */}
        <button
          type="button"
          className="hero-scroll-prompt"
          onClick={handleScrollToTool}
        >
          <span>{t('hero.scrollPrompt')}</span>
          <svg className="hero-scroll-chevron" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
      </div>
    </section>
  );
}
